import * as i0 from '@angular/core';
import { Injectable, EventEmitter, HostListener, ViewChildren, Output, Input, ChangeDetectionStrategy, Component } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import * as i3 from '@angular/forms';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import * as i2 from 'ngx-markdown';
import { MarkdownModule } from 'ngx-markdown';
import { BehaviorSubject, of, combineLatest } from 'rxjs';
import { shareReplay, map, switchMap } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
const _c0 = ["tabElement"];
const _c1 = (a0, a1) => ({
  "with-header": a0,
  "with-footer": a1
});
const _c2 = a0 => ({
  "is-active": a0
});
const _forTrack0 = ($index, $item) => $item.label;
function ModalComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.modalTitle);
  }
}
function ModalComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function ModalComponent_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.close.emit());
    });
    i0.ɵɵtext(1, "\u2716");
    i0.ɵɵelementEnd();
  }
}
function ModalComponent_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 11, 0);
    i0.ɵɵlistener("click", function ModalComponent_For_6_Template_a_click_0_listener() {
      const ɵ$index_15_r4 = i0.ɵɵrestoreView(_r3).$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.openTabIndex$.next(ɵ$index_15_r4));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r5 = ctx.$implicit;
    const ɵ$index_15_r4 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2, ctx_r0.openTabIndex$.getValue() === ɵ$index_15_r4));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", tab_r5.label, " ");
  }
}
function ModalComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "footer")(1, "div", 12);
    i0.ɵɵelement(2, "input", 13);
    i0.ɵɵelementStart(3, "label", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "button", 15);
    i0.ɵɵlistener("click", function ModalComponent_Conditional_12_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.acceptedPrivacy());
    });
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r0.formAccepted);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.mandatoryCheckboxLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !ctx_r0.formAccepted.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.mandatorySubmitLabel, " ");
  }
}
function PrivacyComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.icon);
  }
}
function PrivacyComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function PrivacyComponent_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showModal = true);
    });
    i0.ɵɵtemplate(1, PrivacyComponent_Conditional_0_Conditional_1_Template, 1, 2, "i", 3);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.icon ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.openLabel);
  }
}
function PrivacyComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "jump-rgpd-modal", 4);
    i0.ɵɵlistener("close", function PrivacyComponent_Conditional_1_Template_jump_rgpd_modal_close_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close());
    })("accepted", function PrivacyComponent_Conditional_1_Template_jump_rgpd_modal_accepted_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.acceptedPrivacy());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("modalTitle", ctx_r1.modalTitle)("isMandatory", ctx_r1.isMandatory)("mandatoryCheckboxLabel", ctx_r1.mandatoryCheckboxLabel)("mandatorySubmitLabel", ctx_r1.mandatorySubmitLabel);
  }
}
class PrivacyTab {}
let PrivacyService = /*#__PURE__*/(() => {
  class PrivacyService {
    constructor(http) {
      this.http = http;
      this._tabs$ = new BehaviorSubject([]);
      this.tabs$ = this._tabs$.asObservable();
    }
    initPrivacy(tabs, jsonUrl, json) {
      if (jsonUrl) {
        this._json = this.http.get(jsonUrl).pipe(shareReplay(1));
      } else {
        this._json = of(json);
      }
      const mappedContent = tabs.map(t => ({
        ...t,
        content$: this._getContent$(t.url)
      }));
      this._tabs$.next(mappedContent);
    }
    _getContent$(url) {
      return combineLatest([this.http.get(url, {
        responseType: 'text'
      }), this._json]).pipe(map(([content, json]) => parseContent(content, json)), shareReplay(1));
    }
    /** @nocollapse */
    static {
      this.ɵfac = function PrivacyService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PrivacyService)(i0.ɵɵinject(i1.HttpClient));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PrivacyService,
        factory: PrivacyService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PrivacyService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function getItemInJson(p, o) {
  return p.reduce((xs, x) => xs && xs[x] ? xs[x] : null, o);
}
function parseContent(content, json) {
  // permet de repérer tous les each contenue dans le 'content'
  // et les remplace les version templaté à partir du JSON
  const regExp = /{{#each(.|\n|\r)*?{{\/each}}/gm; // Repère tous les Each du markdown
  const allEach = content.match(regExp) || [];
  for (let singleEach of allEach) {
    const regExp2 = /{{#each\s+(.*?)\s+}}((.|\n|\r)*){{\/each}}/; // Découpe 1 each pour extraire la clé et le contenu à templater
    const capture = singleEach.match(regExp2);
    const keyMain = capture[1];
    const eachTemplate = capture[2];
    const result = getItemInJson(keyMain.split('.'), json);
    let concatenatedLines = '';
    if (!result) {
      console.error('key not defined', keyMain);
      continue;
    }
    for (let eachLineArray of result) {
      const templatedLine = parseContent(eachTemplate, eachLineArray);
      concatenatedLines = concatenatedLines + templatedLine;
    }
    content = content.replace(singleEach, concatenatedLines);
  }
  // repère toutes les accolades contenu dans le content (hors listes)
  // supprime ces accolades et les remplace par les valeurs contenu dans le json.
  const regex = /{{.+?}}/g;
  const matched = content.match(regex) || [];
  const found = matched.map(s => s.slice(2, -2).trim());
  found.forEach((key, index) => {
    const result = getItemInJson(key.split('.'), json);
    if (result) {
      content = content.replace(matched[index], result);
    } else {
      console.error('La clé ' + key + " n'est pas définie.");
    }
  });
  return content;
}
let ModalComponent = /*#__PURE__*/(() => {
  class ModalComponent {
    constructor(privacyService, changeDetectorRef) {
      this.privacyService = privacyService;
      this.changeDetectorRef = changeDetectorRef;
      this.tabs$ = this.privacyService.tabs$;
      this.openTabIndex$ = new BehaviorSubject(0);
      this.displayedContent$ = combineLatest([this.tabs$, this.openTabIndex$]).pipe(switchMap(([tabs, index]) => tabs[index].content$));
      this.close = new EventEmitter();
      this.accepted = new EventEmitter();
      this.formAccepted = new FormControl(false);
    }
    ngOnInit() {
      window.addEventListener('keydown', event => this.closeOnEscape(event));
    }
    ngAfterViewInit() {
      this.changeDetectorRef.detectChanges();
    }
    closeOnEscape(event) {
      if (event.code === 'Escape' && !this.isMandatory) {
        this.close.emit();
      }
    }
    closeOnClickOutside(event) {
      if (event.target === event.currentTarget && !this.isMandatory) {
        this.close.emit();
      }
    }
    getPositionY() {
      if (!this.tabElementList) {
        // après le tout premier cycle, les éléments ne sont pas rendu
        return;
      }
      const currentTabElement = this.tabElementList.toArray()[this.openTabIndex$.getValue()];
      return currentTabElement.nativeElement.offsetTop;
    }
    acceptedPrivacy() {
      this.accepted.emit();
      this.close.emit();
    }
    /** @nocollapse */
    static {
      this.ɵfac = function ModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalComponent)(i0.ɵɵdirectiveInject(PrivacyService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalComponent,
        selectors: [["jump-rgpd-modal"]],
        viewQuery: function ModalComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabElementList = _t);
          }
        },
        hostBindings: function ModalComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function ModalComponent_click_HostBindingHandler($event) {
              return ctx.closeOnClickOutside($event);
            });
          }
        },
        inputs: {
          modalTitle: "modalTitle",
          isMandatory: "isMandatory",
          mandatoryCheckboxLabel: "mandatoryCheckboxLabel",
          mandatorySubmitLabel: "mandatorySubmitLabel"
        },
        outputs: {
          close: "close",
          accepted: "accepted"
        },
        decls: 13,
        vars: 14,
        consts: [["tabElement", ""], [1, "privacy-modal"], [1, "privacy-modal-title"], [1, "privacy-modal-body", 3, "ngClass"], [1, "privacy-close"], [1, "privacy-tabs"], [1, "privacy-tab", 3, "ngClass"], [1, "privacy-current-arrow"], [1, "privacy-content"], [3, "data"], [1, "privacy-close", 3, "click"], [1, "privacy-tab", 3, "click", "ngClass"], [1, "checkbox-valid"], ["type", "checkbox", "id", "checkValid", 3, "formControl"], ["for", "checkValid"], [1, "privacy-checked", 3, "click", "disabled"]],
        template: function ModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, ModalComponent_Conditional_1_Template, 2, 1, "h1", 2);
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵtemplate(3, ModalComponent_Conditional_3_Template, 2, 0, "button", 4);
            i0.ɵɵelementStart(4, "header", 5);
            i0.ɵɵrepeaterCreate(5, ModalComponent_For_6_Template, 3, 4, "a", 6, _forTrack0);
            i0.ɵɵpipe(7, "async");
            i0.ɵɵelement(8, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 8);
            i0.ɵɵelement(10, "markdown", 9);
            i0.ɵɵpipe(11, "async");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, ModalComponent_Conditional_12_Template, 7, 4, "footer");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.modalTitle ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c1, !!ctx.modalTitle, ctx.isMandatory));
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isMandatory ? 3 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(i0.ɵɵpipeBind1(7, 7, ctx.tabs$));
            i0.ɵɵadvance(3);
            i0.ɵɵstyleProp("top", ctx.getPositionY(), "px");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("data", i0.ɵɵpipeBind1(11, 9, ctx.displayedContent$));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isMandatory ? 12 : -1);
          }
        },
        dependencies: [AsyncPipe, NgClass, MarkdownModule, i2.MarkdownComponent, ReactiveFormsModule, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.FormControlDirective],
        styles: ["[_nghost-%COMP%]{position:fixed;bottom:0;left:0;display:flex;align-items:center;justify-content:center;width:100vw;height:100vh;background:#0000004d;z-index:99999;overflow:auto}[_nghost-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box}.privacy-modal[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column;height:80vh;width:80vw;max-width:1280px;background-color:#fff;box-shadow:0 0 10px 1px var(--rgpd-color-privacy-grey-medium);border-radius:10px;overflow:hidden}@media screen and (max-width: 1024px){.privacy-modal[_ngcontent-%COMP%]{flex-direction:column}}@media screen and (max-width: 768px){.privacy-modal[_ngcontent-%COMP%]{height:90vh;width:90vw}}.privacy-modal-title[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center;justify-content:center;height:80px;width:100%;text-align:center;text-transform:uppercase;background-color:var(--rgpd-color-bizness-corail);color:var(--rgpd-color-privacy-grey-light);padding:10px;font-size:1.2em}.privacy-modal-title[_ngcontent-%COMP%]:after{content:\"\";position:absolute;bottom:0;left:0;width:100%;height:10px;background-image:linear-gradient(transparent,#000 200%);opacity:.3}.privacy-modal-body[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:row;width:100%;height:100%}.privacy-modal-body.with-header[_ngcontent-%COMP%], .privacy-modal-body.with-footer[_ngcontent-%COMP%]{height:calc(100% - 80px)}.privacy-modal-body.with-header.with-footer[_ngcontent-%COMP%]{height:calc(100% - 160px)}@media (max-width: 1024px){.privacy-modal-body[_ngcontent-%COMP%]{flex-direction:column}}.privacy-tabs[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column;justify-content:flex-start;height:100%;width:40%;max-width:300px;min-width:300px;padding:15px 30px}@media screen and (max-width: 1024px){.privacy-tabs[_ngcontent-%COMP%]{height:90px;width:100%;max-width:100%;min-width:100%}}.privacy-tabs[_ngcontent-%COMP%]   .privacy-tab[_ngcontent-%COMP%]{font-size:.9em;font-weight:700;text-transform:uppercase;color:var(--rgpd-color-privacy-grey-medium);line-height:1.2em;-webkit-user-select:none;user-select:none;overflow-y:hidden;cursor:pointer;margin-bottom:5px}@media screen and (max-width: 568px){.privacy-tabs[_ngcontent-%COMP%]   .privacy-tab[_ngcontent-%COMP%]{font-size:.8em}}@media screen and (max-width: 420px){.privacy-tabs[_ngcontent-%COMP%]   .privacy-tab[_ngcontent-%COMP%]{font-size:.7em}}.privacy-tabs[_ngcontent-%COMP%]   .privacy-tab.is-active[_ngcontent-%COMP%]{color:var(--rgpd-color-bizness-corail)}.privacy-tabs[_ngcontent-%COMP%]   .privacy-current-arrow[_ngcontent-%COMP%]{position:absolute;width:0;height:0;left:15px;border-style:solid;border-width:4px 0 4px 8px;border-color:transparent transparent transparent var(--rgpd-color-bizness-corail);margin-top:5px;transition:all .2s ease-out}.privacy-close[_ngcontent-%COMP%]{position:absolute;top:0;right:20px;border:none;background:transparent;outline:none;font-size:1.2em;color:var(--rgpd-color-privacy-grey-light);cursor:pointer;padding:4px 8px}@media screen and (max-width: 1024px){.privacy-close[_ngcontent-%COMP%]{top:0;right:0}}.privacy-close[_ngcontent-%COMP%]:hover{color:var(--rgpd-color-privacy-grey-dark)}.privacy-content[_ngcontent-%COMP%]{height:100%;width:100%;overflow-x:hidden;overflow-y:auto;color:var(--rgpd-color-privacy-grey-dark);background-image:linear-gradient(white,var(--rgpd-color-privacy-grey-light));border-left:1px solid var(--rgpd-color-privacy-grey-light);font-size:.9em;padding:2%}@media screen and (max-width: 1024px){.privacy-content[_ngcontent-%COMP%]{font-size:.8em;height:calc(100% - 90px);border-top:1px solid var(--rgpd-color-privacy-grey-light);border-left:0}}.privacy-content[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{border-radius:0}markdown[_ngcontent-%COMP%]     h3{font-size:1.5em;font-weight:900;color:var(--rgpd-color-bizness-corail);margin-bottom:20px}markdown[_ngcontent-%COMP%]     h3:not(:first-of-type){margin-top:40px}markdown[_ngcontent-%COMP%]     h4{font-size:1.2em;margin-bottom:5px;margin-top:15px}markdown[_ngcontent-%COMP%]     p{line-height:1.5em}markdown[_ngcontent-%COMP%]     strong{color:var(--rgpd-color-bizness-deepblue)}markdown[_ngcontent-%COMP%]     a{color:var(--rgpd-color-bizness-corail)}markdown[_ngcontent-%COMP%]     ul{margin-bottom:10px;margin-top:10px}markdown[_ngcontent-%COMP%]     ul li{margin-left:15px;margin-bottom:5px}markdown[_ngcontent-%COMP%]     table{width:100%;border:1px solid var(--rgpd-color-privacy-grey-medium);border-collapse:collapse;margin:10px 0}markdown[_ngcontent-%COMP%]     table tr, markdown[_ngcontent-%COMP%]     table th, markdown[_ngcontent-%COMP%]     table td{background-color:#fff;border:1px solid var(--rgpd-color-privacy-grey-medium);font-size:10px;padding:3px}@media screen and (max-width: 768px){markdown[_ngcontent-%COMP%]     table tr, markdown[_ngcontent-%COMP%]     table th, markdown[_ngcontent-%COMP%]     table td{font-size:.8em}}footer[_ngcontent-%COMP%]{width:100%;height:80px;position:absolute;bottom:0;display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:var(--rgpd-color-bizness-deepblue);color:var(--rgpd-color-privacy-grey-light);padding:15px}footer[_ngcontent-%COMP%]   .checkbox-valid[_ngcontent-%COMP%]{margin-bottom:10px}footer[_ngcontent-%COMP%]   .checkbox-valid[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{margin-right:10px}footer[_ngcontent-%COMP%]   .checkbox-valid[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-size:.9rem}footer[_ngcontent-%COMP%]   button.privacy-checked[_ngcontent-%COMP%]{font-size:1rem;border-radius:0;background-color:var(--rgpd-color-bizness-corail);color:var(--rgpd-color-privacy-grey-light);border:none;padding:5px 15px;cursor:pointer}"],
        changeDetection: 0
      });
    }
  }
  return ModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PrivacyComponent = /*#__PURE__*/(() => {
  class PrivacyComponent {
    constructor(privacyService) {
      this.privacyService = privacyService;
      this.cguUrl = 'templates/TEMPLATE_CGU v1.0.md';
      this.cguLabel = 'CGU';
      this.politicUrl = 'templates/TEMPLATE_POLITIQUE_DE_CONFIDENTIALITE v1.0.md';
      this.politicLabel = 'Politique de confidentialité';
      this.termsUrl = 'templates/TEMPLATE_MENTIONS_LEGALES v1.0.md';
      this.termsLabel = 'Mentions légales';
      this.mandatoryCheckboxLabel = "J'ai lu et j'accepte les CGU et la politique de confidentialité";
      this.mandatorySubmitLabel = 'Je valide';
      this.accepted = new EventEmitter();
      this.closed = new EventEmitter();
      this.showModal = false;
    }
    ngOnInit() {
      if (!this.jsonUrl && !this.json) {
        console.error('Le json contenant les variables est manques (jsonUrl ou json)', this.jsonUrl, this.json);
      }
      if (typeof this.open === 'string') {
        this.open = this.open.toLowerCase() === 'true' ? true : false;
      }
      if (typeof this.hiddenBtn === 'string') {
        this.hiddenBtn = this.hiddenBtn.toLowerCase() === 'true' ? true : false;
      }
      if (typeof this.isMandatory === 'string') {
        this.isMandatory = this.isMandatory.toLowerCase() === 'true' ? true : false;
      }
      this.privacyService.initPrivacy([{
        label: this.cguLabel,
        url: this.cguUrl
      }, {
        label: this.politicLabel,
        url: this.politicUrl
      }, {
        label: this.termsLabel,
        url: this.termsUrl
      }], this.jsonUrl, this.json);
      if (this.open) {
        this.showModal = true;
      }
    }
    acceptedPrivacy() {
      this.accepted.emit();
    }
    close() {
      this.showModal = false;
      this.closed.emit();
    }
    /** @nocollapse */
    static {
      this.ɵfac = function PrivacyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PrivacyComponent)(i0.ɵɵdirectiveInject(PrivacyService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PrivacyComponent,
        selectors: [["jump-rgpd-privacy"]],
        inputs: {
          open: "open",
          openLabel: [0, "open-label", "openLabel"],
          hiddenBtn: [0, "hidden-btn", "hiddenBtn"],
          cguUrl: [0, "cgu-url", "cguUrl"],
          cguLabel: [0, "cgu-label", "cguLabel"],
          politicUrl: [0, "politic-url", "politicUrl"],
          politicLabel: [0, "politic-label", "politicLabel"],
          termsUrl: [0, "terms-url", "termsUrl"],
          termsLabel: [0, "terms-label", "termsLabel"],
          jsonUrl: [0, "json-url", "jsonUrl"],
          json: "json",
          modalTitle: [0, "modal-title", "modalTitle"],
          isMandatory: [0, "is-mandatory", "isMandatory"],
          mandatoryCheckboxLabel: [0, "mandatory-checkbox-label", "mandatoryCheckboxLabel"],
          mandatorySubmitLabel: [0, "mandatory-submit-label", "mandatorySubmitLabel"],
          icon: "icon"
        },
        outputs: {
          accepted: "accepted",
          closed: "closed"
        },
        decls: 2,
        vars: 2,
        consts: [["type", "button", 1, "privacy-btn"], [3, "modalTitle", "isMandatory", "mandatoryCheckboxLabel", "mandatorySubmitLabel"], ["type", "button", 1, "privacy-btn", 3, "click"], [3, "class"], [3, "close", "accepted", "modalTitle", "isMandatory", "mandatoryCheckboxLabel", "mandatorySubmitLabel"]],
        template: function PrivacyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PrivacyComponent_Conditional_0_Template, 4, 2, "button", 0)(1, PrivacyComponent_Conditional_1_Template, 1, 4, "jump-rgpd-modal", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.hiddenBtn ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showModal ? 1 : -1);
          }
        },
        dependencies: [ModalComponent],
        styles: ["[_nghost-%COMP%]{font-size:16px;font-family:Montserrat,sans-serif;text-align:left;--rgpd-color-privacy-grey-light: #ececec;--rgpd-color-privacy-grey-medium: #7e7e7e;--rgpd-color-privacy-grey-dark: #292929;--rgpd-color-bizness-corail: #e4595b;--rgpd-color-bizness-deepblue: #173640}.privacy-btn[_ngcontent-%COMP%]{color:#fff;position:absolute;bottom:15px;left:50%;transform:translate(-50%);background-color:transparent;box-shadow:none;font-family:inherit;font-size:12px;font-weight:600;outline:0;border:0;text-shadow:0 0 3px black;cursor:pointer}i[_ngcontent-%COMP%]{margin-right:5px;font-size:16px}"],
        changeDetection: 0
      });
    }
  }
  return PrivacyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of jump-rgpd
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PrivacyComponent };
